import { compose } from 'recompose';
import { connect } from 'react-redux';
import { ProtectedRouteComponent } from './protected-route.component';
import { loginConnector } from 'src/scenes/login/store/login.selector';

export const ProtectedRoute = compose(connect(loginConnector, null))(
  ProtectedRouteComponent,
);
